import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

//Components
import { DashboardWrapper } from "../../layout/dashboardWrapper"
import { DashboardUserStats } from "../../components/dashboard-user-stats"
import { Table } from "../../components/table/table"
import { RowDots } from "../../components/table/row-menu";

//Styles
import { StyledTableContainer, StyledStatusPill } from '../../styles/users'

//Icons
import { IoEyeOutline } from "react-icons/io5"
import { FiUserX, FiUserCheck } from "react-icons/fi"
import TableTitle from "../../components/table/table-title";
import { TableOptions } from "../../components/table/table-options";
import userData from '../../services/userData.json'


const DashboardUsers = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * pageSize;
        const lastPageIndex = firstPageIndex + pageSize;
        return userData.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, pageSize]);

    //Intialize the useNaviagte hook
    const navigate = useNavigate();

    //Table columns
    const columns = [
        {
            name: <TableTitle title="organization" />,
            selector: (row) => row.organization,
            // sortable: true,
            maxWidth: "130px",
        },
        {
            name: <TableTitle title="Username" />,
            selector: (row) => row.username,
            // sortable: true,
            maxWidth: "125px",
        },
        {
            name: <TableTitle title="email" />,
            selector: (row) => row.email,
            // sortable: true,
            maxWidth: "125px",
        },
        {
            name: <TableTitle title="Phone number" />,
            selector: (row) => row.phoneNumber,
            // sortable: true,
            maxWidth: "125px",
        },
        {
            name: <TableTitle title="Date joined" />,
            selector: (row) => row.dateJoined,
            // sortable: true,
            maxWidth: "125px",
        },
        {
            name: <TableTitle title="Status" />,
            selector: (row) => <StyledStatusPill status={row.status}>{row.status}</StyledStatusPill>,
            maxWidth: "120px",
        },
        {
            name: "",
            selector: (row) => row.status,
            width: "20px",
            cell: (row) => {
                return (
                    <RowDots
                        options={[
                            { name: "View Details", icon: <IoEyeOutline /> },
                            { name: "Blacklist User", icon: <FiUserX /> },
                            { name: "Activate User", icon: <FiUserCheck /> },
                        ]}
                        optionsFns={[
                            () => navigate("/dashboard/users/details"),
                            () => console.log("Blacklisted"),
                            () => console.log("Activated"),
                        ]}
                    />
                );
            },
        },
    ];

    return (
        <DashboardWrapper>
            {/* use of inline style here. BAD PRACTICE!!! */}
            <h2 style={{
                fontWeight: 500,
                fontSize: "24px",
                color: "#213F7D",
            }}>Users</h2>
            <DashboardUserStats />
            <StyledTableContainer>
                <Table
                    columns={columns}
                    data={currentTableData || []}
                />

            </StyledTableContainer>
            <TableOptions
                currentPage={currentPage}
                totalCount={userData.length}
                pageSize={pageSize}
                setPageSize={setPageSize}
                onPageChange={page => setCurrentPage(page)}
            />
        </DashboardWrapper>
    )
}

export default DashboardUsers